import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import {
  hiringEventIncludedSchema,
  interviewSettingsIncludeSchema,
  requirementIncludeSchema,
  workerRequirementIncludeSchema,
  workplaceIncludeSchema,
} from "@src/appV2/redesign/HiringFeed/api/hiringFeed.schema";
import {
  placementDataSchema,
  tagIncludeSchema,
} from "@src/appV2/redesign/Placements/types/fetchPlacements.schema";
import { z } from "zod";

import { workerFavoritePlacementDataSchema } from "../types/workerFavoritePlacement.schema";

const getWorkerFavoritePlacementsIncludedSchema = z.discriminatedUnion("type", [
  placementDataSchema,
  workplaceIncludeSchema,
  hiringEventIncludedSchema,
  interviewSettingsIncludeSchema,
  workerRequirementIncludeSchema,
  requirementIncludeSchema,
  tagIncludeSchema,
]);

const getWorkerFavoritePlacementsResponseSchema = z.object({
  data: z.array(workerFavoritePlacementDataSchema),
  included: z.array(getWorkerFavoritePlacementsIncludedSchema),
});

export type GetWorkerFavoritePlacementsResponse = z.infer<
  typeof getWorkerFavoritePlacementsResponseSchema
>;

interface UseGetWorkerFavoritePlacementsParams {
  workerId: string;
  staleTime?: number;
  enabled?: boolean;
}

// Main hook
export function useGetWorkerFavoritePlacements(
  params: UseGetWorkerFavoritePlacementsParams,
  options?: UseGetQueryOptions<GetWorkerFavoritePlacementsResponse>
) {
  const { workerId } = params;

  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/favorite-placements`,
    responseSchema: getWorkerFavoritePlacementsResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_WORKER_FAVORITE_PLACEMENTS_FAILURE,
    },
    ...options,
  });
}
